import { ThemeProvider } from '@emotion/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Provider } from 'react-redux';
import { SnackbarMessages } from '@shared/components/SnackBarMessages';
import { ApiErrorHandler } from '@shared/components/ApiErrorHandler';
import AppTheme from './libs/mui/AppTheme';
import IntlComponent from '@shared/components/IntlComponent';
import { queryClient } from '@shared/queries';
import store from './libs/redux/store';
import { AxiosProvider } from './libs/axios/axios';
import { Outlet } from 'react-router-dom';
import { AuthProvider } from '@shared/auth/AuthContext';
export default function Root() {
  return (
    <AxiosProvider>
      <Provider store={store}>
        <AuthProvider>
          <IntlComponent>
            <ThemeProvider theme={AppTheme}>
              <QueryClientProvider client={queryClient}>
                <Outlet />
                <SnackbarMessages />
                <ApiErrorHandler />
                {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
              </QueryClientProvider>
            </ThemeProvider>
          </IntlComponent>
        </AuthProvider>
      </Provider>
    </AxiosProvider>
  );
}
